var map = {
	"./btres_logo.png": "9a27",
	"./company_logo.png": "b403",
	"./emirates_logo.png": "1674",
	"./gds_logo.png": "4f7a",
	"./invoice_logo.png": "ee83",
	"./sabre_logo.png": "8853",
	"./tkconnect_logo.png": "2cd0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ec0";